import env from "@/env"
import fallbackConfig from "@/assets/fallback/fallback.config.json"

export type ImageSpaceName = "Axes" | "Projects" | "Template"

interface FallbackEntry {
  image: string
  items: string[]
}

// Map itemId -> image name
const fallbackMap: Record<string, string> = {}
;(fallbackConfig as FallbackEntry[]).forEach((entry) => {
  entry.items.forEach((itemId) => {
    fallbackMap[itemId] = entry.image
  })
})

function getSpacePath(spaceName: ImageSpaceName) {
  return spaceName === "Template" ? "Templates" : spaceName
}

export function getImageUrl(spaceName: ImageSpaceName, itemId: string): string {
  // Si l'item est dans le fallback, utiliser l'image locale
  if (fallbackMap[itemId]) {
    return require(`@/assets/fallback/${fallbackMap[itemId]}.png`)
  }

  return env.REACT_APP_URL_SPACE.concat("/", getSpacePath(spaceName), "/", itemId, ".png?", new Date().getTime().toString())
}

export function getAxisImageUrl(imageId: string, isDefaultImage: boolean): string {
  // Si l'item est dans le fallback, utiliser l'image locale
  if (fallbackMap[imageId]) {
    return require(`@/assets/fallback/${fallbackMap[imageId]}.png`)
  }

  const path = isDefaultImage ? "/_default/" : "/Axes/"
  return env.REACT_APP_URL_SPACE.concat(path, imageId, ".png?", new Date().getTime().toString())
}

export function getProjectImageUrl(projectResponse: any): string {
  if (projectResponse.image && projectResponse.customImage) {
    return getImageUrl("Projects", projectResponse.id)
  }

  if (projectResponse.Template?.image) {
    return getImageUrl("Template", projectResponse.Template.image)
  }

  return require("@/assets/intro.png")
}
